import api from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';
import type { ApiResponse } from '@/types/common.types';

export interface KioskRateChargeApiResponse {
  bw_rate_per_page: string;
  color_rate_per_page: string;
  duplex_extra_charge: string;
  merchant_fees: string;
  convenience_fee: string;
}

export interface KioskApiResponse {
  id: number;
  vendor_name: string;
  name: string;
  location: string;
  printer_model: string;
  printer_specification: string;
  is_supports_color: boolean;
  is_supports_duplex: boolean;
  is_a4: boolean;
  is_letter: boolean;
  is_legal: boolean;
  a4_count: number;
  letter_count: number;
  legal_count: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  vendor: number;
  rate_charge: KioskRateChargeApiResponse | null;
}

export const kioskService = {
  getById: (kioskId: string) =>
    api.get<ApiResponse<KioskApiResponse>>(
      ENDPOINTS.kiosks.byId(kioskId),
    ),
};